import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { signOut } from 'aws-amplify/auth';

/**
 * Layout (MUI v5)
 * --------------
 * Global app bar with a logout action. Children are rendered beneath.
 */
export default function Layout({ children }: React.PropsWithChildren<{}>) {
	return (
		<>
			<AppBar position="static">
				<Toolbar>
					<Typography variant="h6" sx={{ flexGrow: 1 }}>
						Simplicity
					</Typography>
					<Button color="inherit" onClick={() => signOut()}>
						Logout
					</Button>
				</Toolbar>
			</AppBar>
			{children}
		</>
	);
}
